/**
 * `dbo.EnergyUnit`'s ids (CrownData-SSDT `PopulateEnergyUnit.sql`) - stable reference data, not a
 * locale- or user-dependent value. FU and MJ NE are genuinely different feed-energy systems (not two
 * names for the same number), so this is what code must compare against to tell them apart - never
 * `User.energy_unit`, which the API sends as already-localized display text (e.g. "MJ NE", "FE" in
 * Danish) rather than a stable code, and so never reliably equals a literal 'FU'/'MJ'.
 */
export enum EnergyUnitId {
    Fu = 1,
    MjNe = 2,
}
